// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2r2aa","copyright":"footer-module--copyright--2T6D_"};